import type { FormFieldOption } from '@hcc/types';

/** Wire shapes shared by the mapping editor components. */

export interface SapFormField {
  key: string;
  label: string;
  type: string;
  /** Title of the form page the field sits on; groups the picker. */
  page: string | null;
  options: FormFieldOption[] | null;
}

export interface SapFormSummary {
  key: string;
  title: string;
  fields: SapFormField[];
}

export interface MappingDraft {
  form_key: string | null;
  field_key: string | null;
  value_map: Record<string, string>;
}

export type MappingDrafts = Record<string, MappingDraft>;

export const EMPTY_DRAFT: MappingDraft = { form_key: null, field_key: null, value_map: {} };
